import { Card, InlineStack, BlockStack, Text, Thumbnail, Badge } from '@shopify/polaris';
import { SEARCH_TYPE_OPTIONS } from '#client/components/features/LabelPrinting/utils/styleSearch';

const labelFor = (searchType) => SEARCH_TYPE_OPTIONS.find((option) => option.value === searchType)?.label ?? 'search';

export default function MasterProductCard({ masterProduct, matchedBy }) {
    return (
        <Card>
            <BlockStack gap="200">
                <Text as="h2" variant="headingMd">
                    Master product
                </Text>
                <InlineStack gap="400" blockAlign="center" wrap={false}>
                    <Thumbnail source={masterProduct.image || ''} alt={masterProduct.title} size="large" />
                    <BlockStack gap="100">
                        <Text as="h3" variant="headingLg">
                            {masterProduct.title}
                        </Text>
                        <Text as="span" tone="subdued">
                            Vendor part number: {masterProduct.vendorPartNumber || 'None'}
                        </Text>
                        <Text as="span" tone="subdued">
                            {masterProduct.variantCount} variants
                        </Text>
                        {matchedBy && (
                            <InlineStack>
                                <Badge>{`Matched by ${labelFor(matchedBy.searchType)}: ${matchedBy.term}`}</Badge>
                            </InlineStack>
                        )}
                    </BlockStack>
                </InlineStack>
            </BlockStack>
        </Card>
    );
}
